export default __webpack_public_path__ + "static/fm-da853f1af1a76357be06fd7d9ae8cc86.jpeg";